import { Link, useLocation } from "wouter";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export default function Navigation() {
  const [location] = useLocation();

  const links = [
    { href: "/", label: "Home" },
    { href: "/professional", label: "Professional" },
    { href: "/portfolio", label: "Portfolio" },
    { href: "/under-the-hood", label: "Under the Hood" }
  ];

  return (
    <nav className="sticky top-0 z-50 w-full border-b bg-background/80 backdrop-blur">
      <div className="w-full flex h-14 items-center justify-center">
        <div className="flex gap-6 md:gap-10">
          {links.map((link) => (
            <Link key={link.href} href={link.href}>
              <a className={cn(
                "text-sm font-medium transition-colors hover:text-primary relative",
                location === link.href ? "text-foreground" : "text-muted-foreground"
              )}>
                {link.label}
                {location === link.href && (
                  <motion.div
                    layoutId="underline"
                    className="absolute left-0 right-0 h-0.5 bg-primary bottom-[-4px]"
                  />
                )}
              </a>
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}
